import Global from "./lib/global";
import Logger from "./lib/logger";

const NAME = 'Article';
const idPrefix = 'article-heading-';
const navList = document.querySelector('.site-post-container__nav__list');
const h1 = document.querySelector('.site-post-container-header__headline')
const h2s = document.querySelectorAll('.site-post-container-content h2');

Global();

const init = () => {
  Logger.info(`${NAME} > init...`);

  const arr = Array.from(h2s).filter((h) => h.textContent && h.textContent !== '');
  arr.unshift(h1);

  arr.forEach((h, i) => {
    const id = idPrefix + i;
    const item = document.createElement('li');
    const a = document.createElement('a');
    a.href = `#${id}`;
    a.textContent = i == 0 ? 'Intro' : h.textContent;
    item.appendChild(a);
    navList.appendChild(item);
    h.id = id;
  });
}

init();

// Do not edit below this line...
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
Logger.log(`${NAME} > loaded`);